import { Substep } from "@/features/flow/types";
import { MissingFields } from "@/models/missingFields";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const MISSING_FIELDS_SLICE_INITIAL: MissingFields = {
  substeps: [],
  initialMissingFields: []
};

export const missingFieldsSlice = createSlice({
  name: "missingFields",
  initialState: MISSING_FIELDS_SLICE_INITIAL,

  reducers: {
    setSubstepNamesOfMissingFields: (state, action: PayloadAction<string[]>) => {
      const actionsAsSubsteps = action.payload.map((key) => {
        const value = key.split(".")[1] as Substep;
        if (value === undefined) return null;
        return value;
      });
      state.substeps = actionsAsSubsteps.filter((a) => a !== null);
    },
    setInitialMissingFields: (state, action: PayloadAction<string[]>) => {
      state.initialMissingFields = action.payload as Substep[];
    }
  }
});

export const { setSubstepNamesOfMissingFields, setInitialMissingFields } =
  missingFieldsSlice.actions;
